import React, { type ReactElement } from 'react';

import classNames from 'classnames';

import { CollectionSkeleton } from './components/collection-skeleton';
import {
  ShopItemProductCardSkeleton,
  ShopItemSkeleton,
} from './components/shop-item-skeleton';
import { StoreInfoSkeleton } from './components/store-info-skeleton';
import TextSkeleton from './components/text-skeleton';

interface Props {
  className?: string;
  type?:
    | 'home-slider'
    | 'filter-tag'
    | 'shop-item'
    | 'vendors'
    | 'product-item'
    | 'store-item-info'
    | 'collection'
    | 'text';
  repeat?: number;
  isMobile?: boolean;
}

export const SKELETON_ANIMATION =
  'animate-pulse bg-gradient-to-r from-[#F9F9F9] to-[#F0F0F0]';

const HomeSldierSkeleton = ({ className }: { className?: string }) => {
  return <div className={`w-full ${SKELETON_ANIMATION} ${className || ''}`} />;
};

const FilterTagSkeleton = ({ className }: { className?: string }) => {
  return (
    <div className={`h-10 w-full ${SKELETON_ANIMATION} ${className || ''}`} />
  );
};
const VendorTagSkeleton = ({ className }: { className?: string }) => {
  return (
    <div className={`flex flex-col gap-3 ${className || ''}`}>
      <div
        className={classNames(
          'h-[60px] w-[60px] rounded-xl lg:h-[104px] lg:w-[104px]',
          SKELETON_ANIMATION
        )}
      ></div>
      <div
        className={classNames('h-5 w-full rounded-xl', SKELETON_ANIMATION)}
      ></div>
    </div>
  );
};

export default function Skeleton({
  className,
  type = 'home-slider',
  repeat = 1,
  isMobile = false,
}: Props): ReactElement {
  const getSkeletonComponent = () => {
    switch (type) {
      case 'home-slider':
        return <HomeSldierSkeleton className={className} />;
      case 'filter-tag':
        return <FilterTagSkeleton className={className} />;
      case 'vendors':
        return <VendorTagSkeleton className={className} />;
      case 'shop-item':
        return <ShopItemSkeleton isMobile={isMobile} />;
      case 'product-item':
        return <ShopItemProductCardSkeleton />;
      case 'store-item-info':
        return <StoreInfoSkeleton />;
      case 'collection':
        return <CollectionSkeleton />;
      case 'text':
        return <TextSkeleton />;
      default:
        return <div></div>;
    }
  };

  if (repeat === 1) {
    return getSkeletonComponent();
  }

  return (
    <>
      {Array.from({ length: repeat }).map((_, index) => (
        <React.Fragment key={index}>{getSkeletonComponent()}</React.Fragment>
      ))}
    </>
  );
}
